module.exports = __webpack_public_path__ + "img/pyro_m.292effc8.png";